<template>
  <toggle-button v-model="value" sync class="float-right" :disabled="isDisabled" />
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import config from '@/config';
import axios from 'axios';

export default {
  name: 'Setter',
  props: {
    varItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    ...mapGetters('paid-subscription', [
      'hasReachedMaxArgumentCount',
    ]),
    isDisabled() {
      return (!this.varItem.logging_allowed && !this.varItem.logging_enabled) || (this.hasReachedMaxArgumentCount && !this.varItem.logging_enabled);
    },
    value: {
      get() {
        return this.varItem.logging_enabled;
      },
      async set(value) {
        await this.updateVarItemForLogging(value);
        this.setVarsLoggingEnabled({ varItem: this.varItem, value });
      },
    },
  },
  methods: {
    ...mapActions([
      'setVarsLoggingEnabled',
    ]),
    async updateVarItemForLogging(value) {
      const url = new URL(
        config.ICOOL.API.VAR_ITEM_PATH(this.currentSnapshot.id, this.varItem.id),
        config.ICOOL.BACKEND_HOST,
      ).href;
      try {
        await axios.patch(url, { logging_enabled: value });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>

</style>
